module.exports = __webpack_public_path__ + "media/images/ui__textArrowRight--dark-85b26e1c51bf3fd785202f36488eb749.png";